import { IGetOriginByNameProtocol, IGetOriginByNameProtocolRequest, IGetOriginByNameProtocolResponse } from "../../protocols/origin/IGetOriginByNameProtocol";
import { IOriginsRepository } from "../../repositories/IOriginsRepository";

export class GetOriginByNameUseCase implements IGetOriginByNameProtocol {
  constructor(private originsRepository: IOriginsRepository){}
  async execute({originName}: IGetOriginByNameProtocolRequest): Promise<IGetOriginByNameProtocolResponse> {
    const origin = await this.originsRepository.findByName(originName)

    if(!origin){
      throw new Error('Origin does not exists.')
    }

    return {
      origin
    }
  }
}